module.exports = __webpack_public_path__ + "static/media/90700.0f5c789f.png";